<template>
  <IconBase
    :width="iconSize"
    :height="iconSize"
    icon-color="transparent"
    view-box="0 0 24 24"
  >
    <IconPointDefaultPath
      :bg-color="bgColor"
      :icon-color="iconColor"
      :border-color="borderColor"
    />
  </IconBase>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconPointDefaultPath from "@/common/components/icons/IconPointDefaultPath.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	iconSize: { type: Number, default: 24 },
	bgColor: { type: String, default: "#ffffff" },
	iconColor: { type: String, default: "#ee1c25" },
	borderColor: { type: String, default: "#ee1c25" }
  },
  components: {
    IconBase,
    IconPointDefaultPath
  }
})
export default class IconPointDefault extends Vue {
  iconSize!: string;
  bgColor!: string;
  iconColor!: string;
  borderColor!: string;
}
</script>
